<script>
import gql from 'graphql-tag'
import BaseLayout from '@/components/shared/layout/BaseLayout'
import platformDetect from '@/mixins/platformDetect'
export default {
  name: 'Film',
  data () {
    return {
      container: null,
      page: 1,
      showMoreEnabled: true,
      isVisible: true,
    }
  },
  mixins: [
    platformDetect,
    // getUsagerStatistiques,
  ],
  apollo: {
    container: {
      /*eslint-disable*/
      query: gql `query containers_par_categorie($categorie: String!, $limit: Int, $page: Int){
        containers_par_categorie(categorie: $categorie, limit: $limit){
          id categorie_list description titre medias{
            id position image{titre url description thumbnail} mediable_id mediable_type video{titre link minutage description url}
          }
        }
      }`,
      variables () {
        return { categorie: 'film', limit: 4, page: this.page }
      },
      fetchPolicy: 'cache-first',
      update: data => data.containers_par_categorie,
      /*eslint-enable*/
      loadingKey: 'loading',
      watchLoading (isLoading, countModifier) {
      // isLoading is a boolean
      // countModifier is either 1 or -1
        // console.log('EN CHARGEMENT', isLoading)
      },
    },
  },
  components: {
    BaseLayout,
  },
  mounted () {
    var body = document.getElementById('app')
    body.style.overflow = 'hidden'
    setTimeout(function () {
      // console.log('tete')
      this.isVisible = false
      // console.log(this.isVisible)
      var temp = document.getElementsByClassName('cd-transition-layer')
      temp[0].style.visibility = 'hidden'
      temp[0].style.position = 'fixed'
    }, 3000)
  },
  methods: {
    showMore () {
      if (this.page === 0) { this.page = 1 }
      this.page ++
      this.$apollo.queries.container.fetchMore({
        variables: {
          page: this.page,
        },
        updateQuery: (previousResult, {fetchMoreResult}) => {
          const newRes = fetchMoreResult.container
          const hasMore = fetchMoreResult.container.total
          if (hasMore > 4) {
            this.showMoreEnabled = true
          } else {
            if (hasMore > (4 * (this.page ++))) {
              this.showMoreEnabled = true
            } else {
              this.showMoreEnabled = false
            }
          }
          return {
            container: {
              container: [...previousResult.container, ...newRes],
              hasMore,
            },
          }
        },
      })
    },
  },
}
</script>
<template lang="pug">
base-layout
  div.cd-transition-layer(v-bind:class="{ visible: isVisible }")
  div.bgblackintro
  div.backgroundtexture
  div.animatedgradient
  //- div.backgroundimg
  //- div.backgroundimgborder
  div.film
    //- div.cd-transition-layer(v-bind:class="{ visible: isVisible }")
      div(class='bg-layer')
    div.logosection
      img.logo(src="~@/assets/The_Film_Button.png", width="200px")
      div.introsection Find out more about Dreaming of a Jewish Christmas, see the trailer, watch interview excerpts and read about the many people featured both on and off screen.
      hr.lignemenu.mt4
    div.contentsection.ttu
      div.menucontent
        div.menustyle2
          router-link(to='film/about') About the Film
        div.menustyle2
          router-link(to='film/interviews') Interviews
        div.menustyle2
          router-link(to='/film/about_team') About the Team
        div.menustyle2
          router-link(to='film/credits') Credits
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*ANIMATIONS*/
.logo{
  -moz-animation: swing 2s 3s;
  -webkit-animation: swing 2s 3s;
  animation: swing 2s 3s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
.backgroundtexture{
  -moz-animation: fadeIn 2;
  -webkit-animation: fadeIn 2s;
  animation: fadeIn 2s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}

.logosection{
  -moz-animation: fadeInDown 2s 3s;
  -webkit-animation: fadeInDown 2s 3s;
  animation: fadeInDown 2s 3s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
.menucontent{
  -moz-animation: fadeInUp 2s 3s;
  -webkit-animation: fadeInUp 2s 3s;
  animation: fadeInUp 2s 3s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
.lignemenu{
  -moz-animation: zoomIn 2s 4s;
  -webkit-animation: zoomIn 2s 4s;
  animation: zoomIn 2s 4s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
.bgblackintro{
  position:fixed;
  height:100vh;
  width:100vw;
  background-color: black;
  -moz-animation: fadeOut 2s 3s;
  -webkit-animation: fadeOut 2s 3s;
  animation: fadeOut 2s 3s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
.cd-transition-layer {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 200;
  height: 100%;
  width: 100%;
  opacity: 0;
  /*visibility: hidden;
  overflow: hidden;*/
}
.cd-transition-layer, .bg-layer{
  position: absolute;
  left: 50%;
  top: 50%;
  height: calc(100vw * 0.5625);
  width: calc(100vw * 68);
  /*width: calc(39680px / 9vw);*/
  background: url("~@/assets/transitions/montage_film_transition.jpg") no-repeat 0 0;
  background-size: 100% 100%;
}
@keyframes cd-sequence {
  0% {
    transform: translateY(-50%) translateX(-0.75%);
    opacity: 0;
  }
  25% {
    opacity: 1;
  }
  75% {
    opacity: 1;
  }
  100% {
    transform: translateY(-50%) translateX(-100.75%);
    opacity: 0;
  }
}
.cd-transition-layer.visible {
  /*animation: cd-sequence 2.15s steps(62);*/
  animation: cd-sequence 2.75s steps(68);
  animation-fill-mode: normal;
  /*animation-direction: reverse;*/
  /*animation-timing-function: ease-in;*/
  animation-iteration-count: 1;
  visibility: visible;
}
.animatedgradient{
background: linear-gradient(17deg, #004204, #007c08, #00b80c, #00e10f, #32ff40);
background-size: 1000% 1000%;
min-width:100vw;
width:100%;
opacity:0.5;
min-height:100vh;
height:100%;
z-index:-10;
position:absolute;
mix-blend-mode:hard-light;
-webkit-animation: AnimationName 20s ease infinite;
-moz-animation: AnimationName 20s ease infinite;
-o-animation: AnimationName 20s ease infinite;
animation: AnimationName 20s ease infinite;
}
@-webkit-keyframes AnimationName {
    0%{background-position:0% 46%}
    50%{background-position:100% 55%}
    100%{background-position:0% 46%}
}
@-moz-keyframes AnimationName {
    0%{background-position:0% 46%}
    50%{background-position:100% 55%}
    100%{background-position:0% 46%}
}
@-o-keyframes AnimationName {
    0%{background-position:0% 46%}
    50%{background-position:100% 55%}
    100%{background-position:0% 46%}
}
@keyframes AnimationName {
    0%{background-position:0% 46%}
    50%{background-position:100% 55%}
    100%{background-position:0% 46%}
}
/*ANIMATIONS END*/

@media only screen and (min-width: 320px){
  .backgroundtexture{
  background-image: url("~@/assets/imgs_bg/fond5.jpg");
  background-size: cover;
  background-position:center;
  height: 100%;
  min-height: 100vh;
  width:100vw;
  z-index:-11;
  position:absolute;
  }
  .boutonnext{
    font-family:BritannicBold;
    font-size: 20px;
    /*bottom: 5%;*/
    right: 12%;
    bottom:5%;
    color: white;
    background-color: red;
  }
  .boutonlast{
    font-family:BritannicBold;
    font-size: 20px;
    bottom: 5%;
    left: 12%;
    color: white;
    background-color: red;
  }
  .borderred{
    width:92vw;
    height: 91vh;
    position:absolute;
    border-style: solid;
    border-width: 3px 3px 3px 3px;
    border-color: red;
  }
  .lignemenu{
    width:60%;
    max-width:500px;
    border-color: white;
    margin-bottom:0px !important;
    overflow: visible; /* For IE */
    height: 30px;
    border-style: solid;
    border-width: 1px 0 0 0;
    border-radius: 20px;
  }
  .lignemenu:after{
    display: block;
    content: "";
    height: 30px;
    margin-top: -31px;
    border-style: solid;
    border-color: white;
    border-width: 0 0 1px 0;
    border-radius: 20px;
  }
  .introsection{
    color:white;
    width:85%;
    max-width:400px;
    opacity: 1;
    text-align: center;
    margin: 0 auto;
    line-height: 22px;
    font-size: 18px;
    font-style:italic;
    font-family: Crimson Text;
    /*font-family: BritannicBold;*/
  }
  .film{
    & .titresection{
      font-family:Marketdeco;
      color: red;
      font-size: 20px;
      margin-bottom: 30px;
      & span{
        border-style: solid;
        border-width: 3px 0 3px 0;
        border-color: red;
        padding: 5px 10px 5px 10px;
      }
    }
    & .logosection{
      padding-top: 20%;
    }
    & .menucontent{
      width: 100%;
      & .menustyle{
        width: 280px;
        border-style: solid;
        border-width: 0 0 1px 0;
        text-align: left !important;
        border-color: red;
        padding:10px;
        font-family:Marketdeco;
        color: red;
        font-size: 20px;
        margin: 0 auto;
        margin-bottom: 20px;
      }
      & .menustyle2{
        width:200px;
        margin: 30px auto 20px;
        /*line-height:24px;*/
        font-size:30px;
        /*font-family:Marketdeco;*/
        font-family:Barlow Condensed;
        font-weight: 400;
        /*text-transform: uppercase;*/
      }
      & a{
        color:white;
      }
    }
  }
}
@media only screen and (min-width: 320px) and (max-width: 767px) and (orientation:landscape) {
.boutonnext{
  font-family:BritannicBold;
  font-size: 20px;
  /*bottom: 5%;*/
  right: 55%;
  bottom:3%;
  color: white;
  background-color: red;
}
.boutonlast{
  font-family:BritannicBold;
  font-size: 20px;
  bottom: 3%;
  left: 8%;
  color: white;
  background-color: red;
}
.lignemenu{
  display:none!important;
}
.introsection{
  color:white;
  width:100%;
  max-width:400px;
  opacity: 1;
  text-align: center;
  margin: 0 auto;
  line-height: 22px;
  font-size: 18px;
  font-family: Crimson Text;
  /*font-family: BritannicBold;*/
}
.film{
  & .titrecontent{
    font-family:Marketdeco;
    color: red;
    font-size: 20px;
    margin-bottom: 30px;
    margin-top: 50px;
    & span{
      border-style: solid;
      border-width: 3px 0 3px 0;
      border-color: red;
      padding: 5px 10px 5px 10px;
    }
  }
  & .logosection{
    float:left;
    width: 45%;
    padding-top: 6%;
    padding-left:10%;
    /*height: 100vh;*/
  }
  & .contentsection{
    float:left;
    width: 50%;
    margin-top: 10%;
    margin-left:5%;
    & .menucontent{
      width: 100%!important;
      /*margin-top: 10%;*/
    }
  }
}
}
@media only screen and (min-width: 768px){
  .cd-transition-layer, .bg-layer{
    filter:blur(1px);
  }
  .boutonnext{
    font-family:BritannicBold;
    font-size: 20px;
    bottom: 5%;
    right: 10%;
  }
  .boutonlast{
    font-family:BritannicBold;
    font-size: 20px;
    bottom: 5%;
    left: 10%;
  }
  .film{
    & .logosection{
      padding-top: 18%;
    }
    & .contentsection{
      & .titresection{
        font-family:Marketdeco;
        color: red;
        font-size: 30px;
        margin-bottom: 50px;
        margin-top: 50px;
        & span{
          border-style: solid;
          border-width: 3px 0 3px 0;
          border-color: red;
          padding: 5px 10px 5px 10px;
        }
      }
      & .menucontent{
        width: 100%;
        & .menustyle2{
          width:300px;
          margin: 40px auto 20px;
          /*line-height:24px;*/
          font-size:26px;
        }
      }
    }
  }
}
@media only screen and (min-width: 768px) and (orientation:landscape) {
  .cd-transition-layer, .bg-layer{
    filter:blur(1px);
  }
  .boutonnext{
    font-family:BritannicBold;
    font-size: 20px;
    bottom: 5%;
    right: 10%;
  }
  .boutonlast{
    font-family:BritannicBold;
    font-size: 20px;
    bottom: 5%;
    left: 10%;
  }
  .film{
    & .logosection{
      padding-top: 10%;
    }
  }
}
@media only screen and (min-width: 961px){
  .boutonnext{
    font-family:BritannicBold;
    font-size: 20px;
    bottom: 50%;
    right: 10%;
  }
  .boutonlast{
    font-family:BritannicBold;
    font-size: 20px;
    bottom: 50%;
    left: 10%;
  }
  .film{
    & .logosection{
      padding-top: 10%;
    }
  }
}
@media only screen and (min-width: 1200px){
  .cd-transition-layer, .bg-layer{
    filter:blur(2.5px);
  }
}
</style>



// WEBPACK FOOTER //
// Film.vue?6ec0dbce